/**
 * Zeus main blog — Load more via Shopify Section Rendering API.
 * Progressive enhancement: without JS the control is a normal next-page link.
 */
(function () {
  let popstateBound = false;

  /** Preview / editor query keys that must ride along on Section Rendering fetches. */
  var PRESERVE_PARAMS = ["preview_theme_id", "pb", "view", "_fd", "key", "it"];

  function labels(button) {
    return {
      defaultLabel:
        button.getAttribute("data-load-more-label") ||
        button.querySelector("[data-zeus-blog-load-more-label]")?.textContent ||
        "Load more",
      loadingLabel: button.getAttribute("data-loading-label") || "Loading…",
    };
  }

  /**
   * Build the Section Rendering URL for the next blog page.
   * - Resolve relative paginate URLs against the current page (not origin root).
   * - Keep preview_theme_id so unpublished theme markup is returned.
   */
  function sectionRenderUrl(nextUrl, sectionId) {
    var url = new URL(nextUrl, window.location.href);
    var current = new URL(window.location.href);
    PRESERVE_PARAMS.forEach(function (key) {
      if (current.searchParams.has(key) && !url.searchParams.has(key)) {
        url.searchParams.set(key, current.searchParams.get(key));
      }
    });
    url.searchParams.set("section_id", sectionId);
    return url.toString();
  }

  function pageUrl(nextUrl) {
    var url = new URL(nextUrl, window.location.href);
    var current = new URL(window.location.href);
    PRESERVE_PARAMS.forEach(function (key) {
      if (current.searchParams.has(key) && !url.searchParams.has(key)) {
        url.searchParams.set(key, current.searchParams.get(key));
      }
    });
    url.searchParams.delete("section_id");
    return url.pathname + url.search + url.hash;
  }

  function bindPopstate() {
    if (popstateBound) return;
    popstateBound = true;
    window.addEventListener("popstate", function () {
      window.location.reload();
    });
  }

  function announce(root, message) {
    var live = root && root.querySelector("[data-zeus-blog-load-more-live]");
    if (live) live.textContent = message;
  }

  async function loadNextPage(button) {
    var sectionId = button.getAttribute("data-section-id");
    var nextUrl = button.getAttribute("data-next-url");
    if (!sectionId || !nextUrl) return;

    var root = button.closest("[data-zeus-blog-load-more]");
    var grid = root && root.querySelector("[data-zeus-blog-grid]");
    if (!grid) return;

    var labelInfo = labels(button);
    var defaultLabel = labelInfo.defaultLabel;
    var loadingLabel = labelInfo.loadingLabel;
    var label = button.querySelector("[data-zeus-blog-load-more-label]");
    var previousCount = grid.children.length;

    button.setAttribute("aria-busy", "true");
    if (label) label.textContent = loadingLabel;

    try {
      var response = await fetch(sectionRenderUrl(nextUrl, sectionId), {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (!response.ok) throw new Error("Load more failed: " + response.status);

      var html = await response.text();
      var doc = new DOMParser().parseFromString(html, "text/html");
      var nextGrid = doc.querySelector("[data-zeus-blog-grid]");
      var nextBtn = doc.querySelector("[data-zeus-blog-load-more-btn]");

      if (!nextGrid || !nextGrid.children.length) {
        throw new Error("Load more response missing blog grid items");
      }

      var fragment = document.createDocumentFragment();
      var appendedItems = Array.from(nextGrid.children);
      appendedItems.forEach(function (item) {
        fragment.appendChild(item);
      });
      grid.appendChild(fragment);

      // Newly appended cards are not present when zeus-reveal initializes,
      // so their observer never adds .is-visible. Reveal them after insertion.
      requestAnimationFrame(function () {
        appendedItems.forEach(function (item) {
          item.querySelectorAll(".zeus-reveal").forEach(function (card) {
            card.classList.add("is-visible");
          });
        });
      });

      var addedCount = grid.children.length - previousCount;
      if (addedCount > 0) {
        var liveEl = root && root.querySelector("[data-zeus-blog-load-more-live]");
        var loadedMessage = (liveEl && liveEl.getAttribute("data-loaded-message")) || "More articles loaded";
        announce(root, loadedMessage);
      }

      history.pushState({ zeusBlogLoadMore: true }, "", pageUrl(nextUrl));
      bindPopstate();

      if (nextBtn && nextBtn.getAttribute("data-next-url")) {
        var nextHref = nextBtn.getAttribute("href") || nextBtn.getAttribute("data-next-url");
        button.setAttribute("href", nextHref);
        button.setAttribute("data-next-url", nextBtn.getAttribute("data-next-url"));
        var nextDefaultLabel = nextBtn.getAttribute("data-load-more-label");
        var nextLoadingLabel = nextBtn.getAttribute("data-loading-label");
        if (nextDefaultLabel) button.setAttribute("data-load-more-label", nextDefaultLabel);
        if (nextLoadingLabel) button.setAttribute("data-loading-label", nextLoadingLabel);
        if (label) label.textContent = nextDefaultLabel || defaultLabel;
      } else {
        var wrap = button.closest("[data-zeus-blog-load-more-wrap]");
        if (wrap) wrap.remove();
      }
    } catch (error) {
      console.error(error);
      if (label) label.textContent = defaultLabel;
      // Full navigation keeps preview params via pageUrl when possible.
      window.location.href = pageUrl(nextUrl);
    } finally {
      button.removeAttribute("aria-busy");
    }
  }

  document.addEventListener("click", function (event) {
    var button = event.target.closest("[data-zeus-blog-load-more-btn]");
    if (!button) return;
    event.preventDefault();
    if (button.getAttribute("aria-busy") === "true") return;
    loadNextPage(button);
  });
})();
